import React, { useState } from 'react';
import './App.css';
import Menu from './components/Menu';
import { Container, Row, Col, Navbar, NavbarToggler, NavbarBrand } from 'reactstrap';
import helpers from "./helpers/Utilities";

function Carteira() {

    const [menu, setMenu] = useState(false);
    const toggleMenu = () => { setMenu(!menu); };

    const nome = JSON.parse(localStorage.getItem('usuario_logado')).nome;
    const nascimento = helpers.formatDateBR(JSON.parse(localStorage.getItem('usuario_logado')).nascimento);
    const validade = helpers.formatDateBR(JSON.parse(localStorage.getItem('usuario_logado')).validade);
    const matricula = JSON.parse(localStorage.getItem('usuario_logado')).cpf;
    const rg = JSON.parse(localStorage.getItem('usuario_logado')).rg;
    const cpf = JSON.parse(localStorage.getItem('usuario_logado')).cpf;
    const tpSanguineo = JSON.parse(localStorage.getItem('usuario_logado')).tipo_sanguineo;
    const instrutor = JSON.parse(localStorage.getItem('usuario_logado')).instrutor;
    const faixa = JSON.parse(localStorage.getItem('usuario_logado')).faixa;
    const foto = JSON.parse(localStorage.getItem('usuario_logado')).foto;

    return (
        <div id="wrapper" className={`d-flex ${menu ? 'toggled' : ''}`}>
            <Menu />
            <div id="page-content-wrapper">
                <Navbar className="bg-azul" dark>
                    <NavbarToggler onClick={toggleMenu} className="mr-2 border-0" />
                    <NavbarBrand className='mr-auto'>Carteira Digital</NavbarBrand>
                </Navbar>
                <Container style={{ 'maxWidth': '400px' }}>
                    <Row>
                        <Col className="m-3 border border-blue rounded p-3" style={{ 'height': '600px', 'writingMode': 'vertical-rl', 'textOrientation': 'mixed' }}>
                            <Row className="justify-content-around">
                                <Col xs="3"><img src="logo2.png" alt="Logo FIKM" style={{'width': '80px', 'transform': 'rotate(90deg)'}}></img></Col>
                                <Col xs="6" className="txt-azul pr-4 font-weight-bold">FEDERAÇÃO INTERNACIONAL<br />DE KRAV MAGÁ</Col>
                                { (foto == null || foto == '') &&
                                    <Col xs="3" className="mr-3 text-center"><div className="border rounded p-3 text-center" style={{'width': '80px', 'height': '80px', 'float': 'right', 'lineHeight': '40px'}}><a href="/foto">FOTO</a></div></Col>
                                }
                                {
                                    (foto != null && foto != '') &&
                                    <Col xs="3" className="mr-3 text-center"><a href="/foto"><img src={foto} style={{'transform': 'rotate(90deg)', 'width': '80px', 'float': 'right'}} /></a></Col>
                                }
                            </Row>
                            <Row>
                                <Col xs="3" className="pt-3"><span className="txt-azul font-weight-bold">Nome:</span></Col>
                                <Col xs="9">{nome}</Col>
                            </Row>
                            <Row>
                                <Col xs="3" className="pt-3"><span className="txt-azul font-weight-bold">Matrícula:</span></Col>
                                <Col xs="3">{matricula}</Col>
                                <Col xs="3" className="pt-3"><span className="txt-azul font-weight-bold">Validade:</span></Col>
                                <Col xs="3">{validade}</Col>
                            </Row>
                            <Row>
                                <Col xs="3" className="pt-3"><span className="txt-azul font-weight-bold">Data Nasc.:</span></Col>
                                <Col xs="3">{nascimento}</Col>
                                <Col xs="3" className="pt-3"><span className="txt-azul font-weight-bold">Tipo Sang.:</span></Col>
                                <Col xs="3">{tpSanguineo}</Col>
                            </Row>
                            <Row>
                                <Col xs="3" className="pt-3"><span className="txt-azul font-weight-bold">RG:</span></Col>
                                <Col xs="3">{rg}</Col>
                                <Col xs="3" className="pt-3"><span className="txt-azul font-weight-bold">CPF:</span></Col>
                                <Col xs="3">{cpf}</Col>
                            </Row>
                            <Row>
                                <Col xs="3" className="pt-3"><span className="txt-azul font-weight-bold">Instrutor:</span></Col>
                                <Col xs="3">{instrutor}</Col>
                                <Col xs="3" className="pt-3"><span className="txt-azul font-weight-bold">Faixa:</span></Col>
                                <Col xs="3">{faixa}</Col>
                            </Row>

                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default Carteira;
